module.exports = __webpack_public_path__ + "img/PMM.2e199649.png";